import React from 'react';
import styled from '@emotion/styled';
import { Buttons } from '../../toolympus/components/primitives';
import { Chip } from '@mui/material';

interface Props {
  selected: string[];
  options: string[];
  update: (v: string[]) => void;
}

export const CuratorsSelector = (props: Props) => {
  const { selected, update } = props;
  const options = props.options || [];

  return (
    <ChipsWrapper className="curators-selector" title="Фильтр по куратору. shift+click чтобы выбрать нескольких">
      {options.map(o => (
        <Chip
          label={o}
          size="small"
          variant={selected.includes(o) ? "filled" : "outlined"}
          color={selected.includes(o) ? "primary" : undefined}
          onClick={e => {
            update(selected.includes(o)
              ? (e.shiftKey
                  ? selected.filter(x => x !== o)
                  : [])
              : (e.shiftKey
                  ? [...selected, o]
                  : [o]));
          }}
          />
      ))}      
    </ChipsWrapper>
  );
}

const ChipsWrapper = styled(Buttons)`
  gap: 4px;
`;